const users = [
  {
    matricule: 'b.vansteen',
    password: 'vansteenwinckel77',
    role: 'exploitation, maintenance',
    prenom: 'Benjamin',
    nom: 'Van Steenwinckel'
  },
  {
    matricule: 'a.morini',
    password: 'exploitation',
    role: 'exploitation',
    prenom: 'Aurélie',
    nom: 'Morini'
  },
  {
    matricule: 't.avini',
    password: 'avini93',
    role: 'chauffeur_vtc',
    prenom: 'Thibault',
    nom: 'Avini'
  },
  {
    matricule: 'm.ravichandran',
    password: 'ravi94',
    role: 'chauffeur_vtc',
    prenom: 'Méthusan',
    nom: 'Ravichandran'
  },
  {
    matricule: 'w.belaidi',
    password: 'rbe91100#',
    role: 'DG',
    prenom: 'Waiyl',
    nom: 'Belaidi'
  }
];

export default users;
